import { jsx as E } from "react/jsx-runtime";
import { useRef as L, useCallback as a, useEffect as h } from "react";
import { OnLoadOnErrorDefaults as y, classes as b } from "../utils/component.es.js";
const P = ({
  src: s,
  poster: u,
  className: i = "",
  onLoad: l,
  onError: d,
  style: f
}) => {
  const r = L(null), { onLoad: m, onError: v } = y, t = a(() => {
    l?.();
  }, [m, l]), o = a(() => {
    d?.();
  }, [v, d]), n = a(() => {
    r.current && r.current.play().catch((e) => {
      console.error("Error playing video:", e), o();
    }), t();
  }, [o, t]), c = () => {
    r.current;
  };
  return h(() => {
    const e = r.current;
    return e && (e.addEventListener("loadedmetadata", n), e.addEventListener("volumechange", c), e.addEventListener("error", o)), () => {
      e && (e.removeEventListener("loadedmetadata", n), e.removeEventListener("volumechange", c), e.removeEventListener("error", o));
    };
  }, [o, n]), /* @__PURE__ */ E(
    "video",
    {
      ref: r,
      poster: u,
      style: f,
      src: s,
      className: b(
        "rcl--size-auto rcl--max-h-full rcl--max-w-full rcl--object-contain rcl--object-center",
        i
      ),
      autoPlay: !0,
      loop: !0,
      muted: !0,
      controls: !0,
      playsInline: !0,
      disablePictureInPicture: !0,
      onLoadedData: t
    }
  );
};
export {
  P as default
};
//# sourceMappingURL=VideoPlayer.es.js.map
